var React = require('react');

function AeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.6137 75.0296L19.5729 53.9343H53.3906L60.3499 75.0296H72.8548L48.1712 0H24.7924L0 75.0296H12.6137ZM36.4274 2.39225L50.0197 43.7129H22.8351L36.4274 2.39225Z","fill":"black","key":0}),React.createElement("path",{"d":"M203.82 75.0296V64.9169H92.8285V41.5381H201.972V31.4254H92.8285V10.1127H202.95V0H80.541V75.0296H203.82Z","fill":"black","key":1})]);
}

AeInline.defaultProps = {"width":"204","height":"76","viewBox":"0 0 204 76","fill":"none"};

module.exports = AeInline;

AeInline.default = AeInline;
